<template>
    <div>
        <rkm-form
            ref="Form"
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input-autocomplete
                        :repository="repositories.municipio"
                        :search-fields="fields.municipio"
                        :text-field="value => `${value.nome} - ${value.estado.uf}`"
                        :validations="validations.municipio"
                        label="Município"
                        uppercase
                        v-model="model.municipio"
                    />
                </rkm-col>

                <rkm-col>    
                    <rkm-form-input-autocomplete
                        v-if="model.searchByBaseEnderecoNacional && !id"
                        :repository="repositories.logradouro"
                        :request-query-string-params="{municipio_id: model.municipio && model.municipio.id, search_by_base_endereco_nacional: model.searchByBaseEnderecoNacional}"
                        :search-fields="fields.logradouro"
                        :text-field="(value) => `${value.logradouroNome} - ${value.bairroNome}`"
                        :validations="validations.nome"
                        label="Logradouro"
                        placeholder="Informe o nome do logradouro para pesquisar na base nacional"
                        uppercase
                        v-model="model.logradouro"
                    />  
                    <rkm-form-input
                        v-else
                        :validations="validations.nome"
                        label="Nome"
                        uppercase
                        v-model="model.nome"
                    />
                </rkm-col>
             </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        v-if="model.searchByBaseEnderecoNacional && !id"
                        :value="model.logradouro && model.logradouro.logradouroTipoNome"
                        disabled
                        label="Tipo"
                    />

                    <rkm-form-select
                        v-else
                        :options="form.tipos"
                        :validations="validations.tipo"
                        label="Tipo"
                        show-default-option
                        text-field="descricao"
                        v-model="model.tipoId"
                        value-field="id"
                    />                   
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        v-if="model.searchByBaseEnderecoNacional && !id"
                        :value="model.logradouro && model.logradouro.logradouroCep"
                        disabled
                        label="CEP"
                        v-mask="mask.cep"
                    />

                    <rkm-form-input
                        v-else
                        :validations="validations.cep"
                        label="CEP"
                        placeholder="99.999-999"
                        v-mask="mask.cep"
                        v-model="model.cep"
                    />
                </rkm-col>
                
                <rkm-col cols="6">
                    <rkm-form-input
                        v-if="model.searchByBaseEnderecoNacional && !id"
                        :value="model.logradouro && model.logradouro.bairroNome"
                        disabled
                        label="Bairro"
                    />

                    <rkm-form-input-autocomplete
                        v-else
                        :repository="repositories.bairro"
                        :searchFields="fields.bairro"
                        :validations="validations.bairro"
                        label="Bairro"
                        uppercase
                        v-model="model.bairro"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-button
                                @click.stop="$refs.ModalBairro.open()"
                                color="primary"
                                title="Cadastrar bairro"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>  
        </rkm-form>
    </div>
</template>
<script>
// Mixins.
import { error, importacaoCns, mask, object, repository, stringCase, unmask } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'


export default{
    computed:{
        ...mapGetters({ cliente: 'getCliente' }),
        fields() {
            return {
                municipio: [
                    { key: 'nome', searchable:true }
                ],
                logradouro  : [
                    { key: 'cadastro_logradouro.nome', searchable: true},
                    { key: 'cadastro_logradouro.cep', searchable: true},
                ],
                bairro: [
                    { key: 'nome', searchable: true}
                ]
            }
        },
        validations() {
            return {
                municipio: { required: true },
                nome: {
                    required: true,
                    min: 1,
                    max: 250,
                    regex: this.importacaoCns.regexValidacao,
                    termo_invalido: this.form.termosInvalidos,
                },
                tipo: { required: true },
                cep: { required: true, min_max_without_mask: 8 },
                bairro: { required: true },
            }
        },
    },
    created(){
            this.repositories = {
            bairro: this.getConectaSusRepository('cadastro.localizacao.bairro'),
            logradouro: this.getConectaSusRepository('cadastro.localizacao.logradouro'),
            municipio: this.getConectaSusRepository('intranet.municipio'),
        }
    },
    data:() => ({
        form: {
            termosInvalidos: [],
            tipos: [],
        },
        model:{
            bairro: null,
            cep: '',
            logradouro: null,
            municipio: null,
            nome: '',
            searchByBaseEnderecoNacional: true,
            tipoId: null,
        }
    }),
    props:{
        id :{ type: Number}
    },

    methods:{
        ...mapActions(['setLoading','unsetLoading']),
        load() {
            this.setLoading()
            
            const request = this.id
                ? this.repositories.logradouro.edit(this.id)
                : this.repositories.logradouro.create()

            request
                .then(({ data }) => {
                    this.form.termosInvalidos = data.form.termosInvalidos
                    this.form.tipos = data.form.tipos

                    if (data.model) {
                        this.model.tipoId = data.model.tipoId
                        this.model.nome = data.model.nome
                        this.model.bairro = data.model.bairro
                        this.model.cep = data.model.cep
                        
                        this.$nextTick(() => this.model.municipio = data.model.municipio)
                    }else{
                        this.$nextTick(() => this.model.municipio = this.cliente.municipio)
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {
            if (this.model.searchByBaseEnderecoNacional && !this.id) {

                const request = {
                    searchByBaseEnderecoNacional: true,
                    municipioId: this.model.municipio.id,
                    logradouroNome: this.model.logradouro.logradouroNome,
                    logradouroTipoNome: this.model.logradouro.logradouroTipoNome,
                    logradouroCep: this.unMaskCep(this.model.logradouro.logradouroCep),
                    bairroNome: this.model.logradouro.bairroNome,
                }

                return this.camelObjectKeysToSnakeRecursive(request)
            } else {

                const logradouro = this.clone(this.model)

                logradouro.cep = this.unMaskCep(logradouro.cep)
                logradouro.bairroId = logradouro.bairro.id
                logradouro.municipioId = logradouro.municipio.id

                delete logradouro.bairro
                delete logradouro.municipio

                return this.camelObjectKeysToSnakeRecursive(logradouro)
            }
        },
        save(){
            this.$refs.Form.validate()
                .then(valid => {
                    if (!valid) return

                    this.setLoading()
                    const request = this.id
                        ? this.repositories.logradouro.update(this.id, this.prepareData())
                        : this.repositories.logradouro.store(this.prepareData())

                    request
                        .then(({ data }) => {
                            this.$emit('select', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        }
    },
    mixins: [ error, importacaoCns, mask, object, repository, stringCase, unmask ],
    mounted(){
        this.load()
    },
}
</script>